export const usernameWrapperHeight = '30px';
export const usernameWrapperBorderRadius = `calc(${usernameWrapperHeight} / 2)`;

export const usernameTextFontSize = '12px';
